import { useState, useCallback } from 'react'
import type { ToastMessage } from '@/lib/types'

interface UseToastResult {
  toasts: ToastMessage[]
  toast: (message: Omit<ToastMessage, 'id'>) => void
  dismiss: (id: string) => void
}

export function useToast(): UseToastResult {
  const [toasts, setToasts] = useState<ToastMessage[]>([])

  const toast = useCallback((message: Omit<ToastMessage, 'id'>) => {
    const id = Math.random().toString(36).substring(7)
    const duration = message.duration || 5000

    const newToast: ToastMessage = {
      ...message,
      id,
    }

    setToasts((prev) => [...prev, newToast])

    // Auto-dismiss after duration
    setTimeout(() => {
      dismiss(id)
    }, duration)
  }, [])

  const dismiss = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  return {
    toasts,
    toast,
    dismiss,
  }
}
